<div
  *ngIf="document && content"
  [ngClass]="{ 'has-edit-button': page.isPreview() }"
>
  <div edsGrid>
    <div class="container">
      <div edsRow>
        <div edsCol>
          <eds-title edsSpacing="md">{{ content.displayName }}</eds-title>
          <form>
            <ng-container *ngFor="let field of fields">
              <!-- Text Field -->
              <ng-container *ngIf="field.type === 'TEXT_FIELD'">
                <div edsSpacing="lg">
                  <eds-text-input
                    type="text"
                    [placeholder]="field.hint"
                    [label]="field.label"
                    [name]="field.name"
                    [required]="field.mandatory"
                    [(value)]="field.initialValue"
                    [invalid]="field.invalid"
                    [invalidText]="field.invalidText"
                    (inputTextChange)="onInputTextChange($event, field)"
                  ></eds-text-input>
                </div>
                <!--  -->
              </ng-container>

              <!-- DROPDOWN button -->
              <ng-container *ngIf="field.type === 'DROPDOWN'">
                <div edsSpacing="lg">
                  <eds-dropdown
                    [label]="field.label"
                    [name]="field.name"
                    id="field.id"
                    [items]="items"
                    [titleText]="field.initialText"
                    [required]="field.mandatory"
                  ></eds-dropdown>
                </div>
              </ng-container>

              <!-- Radio Group button -->
              <ng-container *ngIf="field.type === 'RADIOGROUP'">
                <div edsSpacing="lg">
                  <eds-radio-group
                    (radioChange)="onRadioChange($event)"
                    name="{{ field.label }}"
                  >
                    <eds-radio
                      *ngFor="let radio of radioItems"
                      [id]="radio.id"
                      [value]="radio"
                      labelName="{{ radio.label }}"
                    >
                    </eds-radio>
                  </eds-radio-group>
                </div>
              </ng-container>

              <!-- Date Field -->
              <ng-container *ngIf="field.type === 'DATE_FIELD'">
                <div edsSpacing="lg" edsFlexbox alignItems="center">
                  <label for="date">{{ field.label }}</label>
                  <eds-date-picker
                    type="day"
                    id="date.id"
                    [label]="field.label"
                  ></eds-date-picker>
                </div>
              </ng-container>

              <!-- Check box -->
              <ng-container *ngIf="field.type === 'CHECKBOXGROUP'">
                <div edsSpacing="lg">
                  <eds-checkbox
                    *ngFor="let checkbox of checkItems"
                    [id]="checkbox.id"
                    name="field.name"
                    [value]="checkbox"
                    [required]="field.mandatory"
                    labelName="{{ checkbox.label }}"
                  >
                  </eds-checkbox>
                </div>
              </ng-container>

              <!-- Text Area -->
              <ng-container *ngIf="field.type === 'TEXTAREA'">
                <div edsSpacing="lg">
                  <eds-text-area
                    [label]="field.label"
                    [required]="field.mandatory"
                    [rows]="field.rows"
                    [cols]="field.cols"
                    [name]="field.name"
                    aria-label="textArea"
                  ></eds-text-area>
                </div>
              </ng-container>
            </ng-container>
          </form>
          <div edsSpacing="lg">
            <button edsButton>{{ content.buttonLabel }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- no document -->
<div *ngIf="!document && page.isPreview()" class="no-document">
  <div edsGrid class="no-document__component">
    <div class="no-document__overlay">
      Click to configure <strong>Custom Form</strong>
    </div>
  </div>
</div>
